import { theme } from '@/components';

export type Colors =
  | 'normal'
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'quaternary'
  | 'error'
  | 'white';

export const useColor = () => {
  const { token } = theme.useToken();

  const getColorValue = (color: Colors) => {
    switch (color) {
      case 'primary':
        return token.colorPrimary;
      case 'secondary':
        return token.colorTextSecondary;
      case 'tertiary':
        return token.colorTextTertiary;
      case 'quaternary':
        return token.colorTextQuaternary;
      case 'error':
        return token.colorError;
      case 'white':
        return token.colorWhite;
      default:
        return token.colorTextBase;
    }
  };

  return { getColorValue };
};
